module.exports = __webpack_public_path__ + "img/055-burger.b0c4a052.svg";